import { SetStateAction, useEffect, useState } from "react";
import { ObjectGeneric } from "../../../../../utils/types/generals";
import { filesManagerServiceFetch } from "../../../../../utils/constants/callService";
import { returnQuery } from "../../../../../utils/methods/returnQuery";
import { FilterBody } from "../../../../../hooks/filter/typing";
import { useTranslation } from "react-i18next";
import { SolicitedUserRow } from "../components/step1/types";
import { Types } from "../../../../../utils/enums";
import { Box, Checkbox } from "@mui/material";
import { useStyles } from "../styles";


const useBody = ({ userFilter, setModal, setOpenSnackbar, closeModalIndex }: {
    userFilter: FilterBody,
    setModal: (value: SetStateAction<{
        open: boolean;
        title: string;
        description?: string;
        children?: JSX.Element;
        removeCancel?: boolean;
        confirm: () => void;
    }>) => void;
    setOpenSnackbar: (value: SetStateAction<{
        open: boolean;
        message: string;
        type: Types;
    }>) => void;
    closeModalIndex: () => void;
}) => {

    const [file, setFile] = useState<File | null>(null);
    const { t } = useTranslation()
    const [errors, setErrors] = useState<Record<string, string>>({})
    const [data, setData] = useState<ObjectGeneric>({})
    const [requestingUsers, setRequestingUsers] = useState<number[]>([])
    const [loading, setLoading] = useState(false)
    const [row, setRow] = useState<SolicitedUserRow[]>([])
    const [checked, setChecked] = useState(false)
    const styles = useStyles()

    /* const handleSearch = async () => {
        if (requestingUsers.length) {
            setModal(prev => ({
                ...prev,
                open: true,
                title: t("general.userFilterWarningTitle"),
                description: t("general.userFilterWarningDescription"),
                confirm: () => {
                    searchUsersSolicited();
                    //setRequestingUsers([]);
                    closeModalIndex();
                }
            }))
        } else {
            searchUsersSolicited()
        }
    } */

    const searchUsersSolicited = async ({all}:{all:boolean}) => {
        try {
            setLoading(true)
            const response = await filesManagerServiceFetch.getUsersToAddPermissions({ query: all ? returnQuery(userFilter.query, {}) : '' })
            let allUsers: SolicitedUserRow[] = response?.map(item => ({
                id: item.id,
                fullname: item.fullName && item.fullName.trim() !== "" ? item.fullName : "N/A",
                userType: item.userType ?? '',
                curp: item.curp ?? '',
                email: item.email,
                phone: item.phone
            })) ?? []
            if (!!allUsers?.length) {
                setRow(allUsers)
                const allPresent = allUsers.every(user => requestingUsers.includes(user.id))

                const allNotPresent = !allPresent

                if (allNotPresent) {
                    setChecked(false)
                } else {
                    setChecked(true)
                }
            } else {
                setRow([])
                setOpenSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
            }
        } catch (e) {
            setRow([])
            setOpenSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
        }
        finally {
            setLoading(false)
        }
    }

    const handleSelectUser = ({ id, value }: { id: string, value: boolean }) => {
        if (id == 'all') {
            if (value) {
                setRequestingUsers(prev => {
                    const allIds = row.map(r => r.id)
                    const newIds = allIds.filter(id => !prev.includes(id))
                    return [...prev, ...newIds]
                })
                setChecked(true)
            } else {
                setRequestingUsers([])
                setChecked(false)
            }
        } else {
            const numberId = Number(id)
            if (value) {
                setRequestingUsers(prev => [...prev, numberId])
            } else {
                setRequestingUsers(prev => prev.filter(item => item !== numberId))
            }
        }
    }

    const column = [
        {
            id: 'actions',
            rowTdStyles: {
                width: '15px',
            },
            headerCell: {
                width: '15px',
            },
            column: () => {
                return (
                    <Box sx={styles.all} >
                        <Checkbox
                            checked={checked}
                            onChange={(_, check) => {
                                handleSelectUser({ id: 'all', value: check })
                            }}
                            color="primary"
                            className="remove-m"
                        />
                    </Box>
                )
            },
            renderCell: (params: any) => {
                const id = params.row.id
                return (
                    <Box sx={styles.all} >
                        <Checkbox
                            checked={requestingUsers.includes(id)}
                            onChange={(_, check) => {
                                handleSelectUser({ id: id, value: check })
                            }}
                            color="primary"
                        />
                    </Box>
                )
            },
        },
        {
            id: 'fullname',
            label: t('useScheduled.detail.tables.fullname'),
            minWidth: 120,
        },
        {
            id: 'curp',
            label: t('useScheduled.detail.tables.curp'),
            minWidth: 120,
        },
        {
            id: 'userType',
            label: t('useScheduled.detail.tables.userType'),
            minWidth: 120,
        },
        {
            id: 'email',
            label: t('useScheduled.detail.tables.email'),
            minWidth: 120,
        },
        {
            id: 'phone',
            label: t('useScheduled.detail.tables.phone'),
            minWidth: 120,
        },
    ]



    return {
        errors,
        setErrors,
        data,
        setData,
        requestingUsers,
        setRequestingUsers,
        file,
        setFile,
        searchUsersSolicited,
        loading,
        row,
        column
    }
}

export { useBody }
